import { APIClient } from "./_api";

export function startApp() {
  return APIClient.post(`/open`);
}
